import { motion } from "framer-motion";
import { FiCoffee } from "react-icons/fi";

const NoData = () => {
  return (
    <motion.div
      className="flex flex-col items-center justify-center p-8 text-center bg-white border border-gray-200 rounded-md"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.1, type: "spring", stiffness: 200, damping: 10 }}
      >
        <FiCoffee size={48} className="mb-4 text-teal-500" />
      </motion.div>
      <h3 className="mb-2 text-xl font-semibold text-gray-800">
        No Products Found
      </h3>
      <p className="max-w-md text-gray-600">
        We couldn't find any kitchen appliances matching your criteria. Why not
        take a coffee break and try again later?
      </p>
      <motion.button
        className="px-4 py-2 mt-4 font-medium text-white bg-teal-500 rounded-md hover:bg-teal-600"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        Refresh Results
      </motion.button>
    </motion.div>
  );
};

export default NoData;
